import { render, staticRenderFns } from "./Removepassword.vue?vue&type=template&id=20daf0b6&scoped=true"
import script from "./Removepassword.vue?vue&type=script&lang=js"
export * from "./Removepassword.vue?vue&type=script&lang=js"
import style0 from "./Removepassword.vue?vue&type=style&index=0&id=20daf0b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20daf0b6",
  null
  
)

export default component.exports